import { Component, forwardRef, Input } from '@angular/core';

import { InputText } from 'primeng/inputtext';
import {
  AbstractControl,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-input-email',
  imports: [InputText, FormsModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './input-email.component.html',
  styleUrl: './input-email.component.css',

  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputEmailComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputEmailComponent),
      multi: true,
    },
  ],
})
export class InputEmailComponent {
  @Input() placeholder = '';
  @Input() customValidators: ValidatorFn[] = [];
  value = '';
  hasError = false;
  errorMessage = '';

  onTouched: () => void = () => {
    console.warn('onTouched was called before being registered.');
  };

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const validators = [...(this.customValidators ?? []), Validators.email];
    for (const field of validators) {
      const error = field(control);
      if (error) {
        this.hasError = true;
        this.errorMessage = this.extractErrorMessage(error);
        return error;
      }
    }
    this.hasError = false;
    return null;
  }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.onChange(this.value);
  }

  private onChange(_value: string): void {
    void _value;
    console.warn('onChange was called before being registered.');
  }

  private extractErrorMessage(error: ValidationErrors): string {
    for (const key of Object.keys(error)) {
      const message = error[key];
      if (error['email']) {
        return 'auth.errors.email';
      }
      if (typeof message === 'string') {
        return message;
      }
    }
    return 'Valor inválido';
  }
}
